/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  EventVolumeBucket,
  EventVolumeBucket$inboundSchema,
} from "./eventvolumebucket.js";

/**
 * Bucketed counts of logs vs spans over the requested range
 */
export type GetEventVolumeResult = {
  /**
   * Zero-filled buckets in ascending time order
   */
  buckets: Array<EventVolumeBucket>;
  /**
   * Bucket width in seconds
   */
  intervalSeconds: number;
};

/** @internal */
export const GetEventVolumeResult$inboundSchema: z.ZodMiniType<
  GetEventVolumeResult,
  unknown
> = z.pipe(
  z.object({
    buckets: z.array(EventVolumeBucket$inboundSchema),
    interval_seconds: z.int(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "interval_seconds": "intervalSeconds",
    });
  }),
);

export function getEventVolumeResultFromJSON(
  jsonString: string,
): SafeParseResult<GetEventVolumeResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetEventVolumeResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetEventVolumeResult' from JSON`,
  );
}
